import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingPixelateImageConfig } from '@/data/landingConfig/landingPixelateImageConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PixelateImage } from './schemaObject';

interface Props {}

const PixelateImage: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_PixelateImage} />
			<LandingTemplate
				data={landingPixelateImageConfig}
				funnelLinkService={GenerateLandingLinkService.funnelBlur()}
			/>
		</>
	);
};

export default PixelateImage;
